export default "__VITE_ASSET__mqieIp31__"